import { onBeforeUnmount, onMounted, ref, Ref } from "vue";

export const useTooltipVisibility = (valueRef: Ref<HTMLElement | null>) => {
  const mutationObserverConfig = { attributes: true };
  const isElementVisible = ref(false);

  const initIsElementVisible = (element: HTMLElement) => {
    if (element) {
      isElementVisible.value = element.offsetWidth < element.scrollWidth || element.offsetHeight < element.scrollHeight;
    }
    return false;
  };

  const mutationObserverCallback = (mutations: MutationRecord[]) => {
    mutations.forEach((mutation: MutationRecord) => {
      const target = mutation.target as HTMLElement;
      if (mutation.type === "attributes" && target) initIsElementVisible(target);
    });
  };

  const elementMutationObserver = new MutationObserver(mutationObserverCallback);

  onMounted(() => {
    if (!valueRef.value) return;

    initIsElementVisible(valueRef.value);
    elementMutationObserver.observe(valueRef?.value, mutationObserverConfig);
  });

  onBeforeUnmount(() => {
    elementMutationObserver.disconnect();
  });

  return { isElementVisible };
};
